import { Div, FormBuilder, FormInput, H2, Label, Loader } from "@grassrootly/rn-core";
import { ResetPasswordProps, resetPasswordForm } from "./ResetPassword.types";
import { useResetPassword } from "./useResetPassword";

export default function ResetPassword({ authParams, title, body }: ResetPasswordProps) {
  const { onSubmit, loading, authUser, reseting } = useResetPassword(authParams);
  return (
    <Div classNames={["flex1"]}>
      {loading ? (
        <Div classNames={["flex1", "justifyContentCenter", "alignItemsCenter"]}>
          <Loader />
        </Div>
      ) : (
        <Div classNames={["flex1"]}>
          <H2 classNames={["h2", "mb-{16}"]}>{title}</H2>
          <Label classNames={["l2Regular"]}>{body.replace("{{email}}", authUser?.email || "")}</Label>
          <Div classNames={["mt-{24}", "w-{100%}", "maxW-{300}"]}>
            <Div classNames={["mb-{36}"]}>
              <Label>Email</Label>
              <FormInput disabled input={{ value: authUser?.email }} />
            </Div>
            <FormBuilder
              form={resetPasswordForm}
              onSubmit={onSubmit}
              isSubmitting={reseting}
              submitFormOnEnter={true}
            />
          </Div>
        </Div>
      )}
    </Div>
  );
}
